import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class NotifyService {
  constructor(private readonly snackbar: MatSnackBar) {}

  withAutodismiss(msg: string, action?: string) {
    return this.snackbar.open(msg, action, { duration: 5000 });
  }
}
